import React from 'react';
import { useAuth } from '../context/AuthContext';
import PackAndShip from './vendor/PackAndShip';
import Shipping from './Shipping';

/**
 * Role-based Shipping Page Router
 * - Vendors see Pack & Ship (order processing, label generation)
 * - Admins see Shipping Management (tracking overview, settings)
 */
const ShippingRouter = () => {
  const { user } = useAuth();
  
  // Admin roles see the management view
  if (user?.role === 'admin' || user?.role === 'super_admin' || user?.admin_type === 'super_admin') {
    return <Shipping />;
  }
  
  // Vendors see Pack & Ship
  return <PackAndShip />;
};

export default ShippingRouter;
